export default __webpack_public_path__ + "static/pvp_icon-be85392d2b30e13944763f107ca5ca00.png";